import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["avatar", "badge", "size"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BadgedAvatarMixin } from '../../mixins/components/BadgedAvatarMixin';
export var StyledBadgedAvatar = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledBadgedAvatar",
  componentId: "c11n-8-64-0__sc-17j90y9-0"
})(["", ""], BadgedAvatarMixin);
/**
 * Composes an [`Avatar`](#/More%20components?id=avatar) with
 * an [`AvatarBadge`](#/More%20components?id=avatarbadge).
 *
 * @since 7.18.0
 */

var BadgedAvatar = function BadgedAvatar(_ref) {
  var avatar = _ref.avatar,
      badge = _ref.badge,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var avatarClone = /*#__PURE__*/React.cloneElement(avatar, {
    size: size
  });
  var badgeClone = /*#__PURE__*/React.cloneElement(badge, {
    size: size
  });
  return /*#__PURE__*/React.createElement(StyledBadgedAvatar, rest, avatarClone, badgeClone);
};

BadgedAvatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The [`Avatar`](#/More%20components?id=avatar) component.
   */
  avatar: PropTypes.node.isRequired,

  /**
   * The [`AvatarBadge`](#/More%20components?id=avatarbadge) component.
   */
  badge: PropTypes.node.isRequired,

  /**
   * The avatar size. Note: badges should not be used at `'xs'`, `'sm'` and `'md'` sizes.
   */
  size: PropTypes.oneOf(['xxl', 'xl', 'lg'])
} : {};
BadgedAvatar.defaultProps = {
  size: 'lg'
};
export default BadgedAvatar;